import { Component, Input, OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { loadTags, loadTagsWithFree } from '../../util/tag-utils';
import { IConditionalSection } from '../../shared/models/condition-section.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';

@Component({
  selector: 'app-business-amenities',
  templateUrl: './business-amenities.component.html',
  styleUrls: ['./business-amenities.component.scss']
})
export class BusinessAmenitiesComponent implements OnInit, IConditionalSection {
  @Input() business: Business;
  _lineServiceTags: String[] = [];
  _amenitiesTags: String[] = [];
  _internetTags: String[] = [];
  _transportationTags: String[] = [];
  editModeSet = false;
  _creditCardTags: String[] = [];
  isRegionalManager = false;


  constructor(private _toggleService: EditToggleService,
              private _editAmenitiesDialog: MatDialog,
              public snackBar: MatSnackBar,
              private _businessManagerService: BusinessManagerService) {}


  async ngOnInit() {
    this.loadAllTags();

    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
    this.isRegionalManager = await this._businessManagerService.isRegionalManager()
      && !await this._businessManagerService.userOwnsBusiness(this.business.id);
  }

  get hasContent(): boolean {
    return (this._lineServiceTags. length > 0 || this._amenitiesTags.length > 0 ||
      this._internetTags. length > 0 || this._transportationTags.length > 0 ||
      this._creditCardTags.length > 0 || this.editModeSet);
  }

  get lineServiceTags(): String[] {
    return this._lineServiceTags;
  }

  get amenitiesTags(): String[] {
    return this._amenitiesTags;
  }

  get internetTags(): String[] {
    return this._internetTags;
  }

  get transportationTags(): String[] {
    return this._transportationTags;
  }

  get creditCardTags(): String[] {
    return this._creditCardTags;
  }

  get creditCards(): String[] {
    const result: String[] = [];
    for (const currentTag of this.business.tags) {
      if (currentTag.tagName.startsWith('Credit Cards::')) {
        result.push(currentTag.displayName);
      }
    }
    return result.sort();
  }

  loadAllTags() {
    // Load Line Service
    this._lineServiceTags = loadTags(this.business.tags, 'Line Services::', '', '');

    // Load Amenities
    this._amenitiesTags = loadTags(this.business.tags, 'Amenities::', '', 'Amenities::Internet');

    // Load Internet
    this._internetTags = loadTagsWithFree(this.business.tags, 'Amenities::Internet::');

    // Load Transportation
    this._transportationTags = loadTagsWithFree(this.business.tags, 'Transportation::');

    // Load Credit Cards
    this._creditCardTags = loadTags(this.business.tags, 'Credit Cards::', '', '');
  }

  /**
   * Opens modal for editing business overview section, displays snackbar if serverAPI was successfully updated.
   */
  openEditLandingDialog(group: String[], except: String[], title: string): void {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      business: this.business,
      tagsGroup: group,
      except: except,
      title: title
    };

    dialogConfig.width = '95%';
    const dialogRef = this._editAmenitiesDialog.open(EditTagsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isSuccess) => {
      // Load Line Service
      if (isSuccess) {
        this.loadAllTags();
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
